// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setMedicalDeviceOrderingOrderList,
  setMedicalDeviceOrderingEditOrder,
  setMedicalDeviceOrderingCompanyList,
  setMedicalDeviceOrderingPatientAddresses,
  setMedicalDeviceOrderingPatientProfile,
  setMedicalDeviceOrderingTypeList,
  resetMedicalDeviceOrdering
} from 'src/store/modules/admin/medicalDeviceOrdering'

const initialState = {
  orderList: [],
  editOrder: {},
  companyList: [],
  patientAddresses: [],
  patientProfile: {},
  typeList: []
}

export default handleActions(
  {
    [setMedicalDeviceOrderingOrderList](state, { payload: orderList }) {
      return {
        ...state,
        orderList
      }
    },

    [setMedicalDeviceOrderingEditOrder](state, { payload: editOrder }) {
      return {
        ...state,
        editOrder
      }
    },

    [setMedicalDeviceOrderingCompanyList](state, { payload: companyList }) {
      return {
        ...state,
        companyList
      }
    },

    [setMedicalDeviceOrderingPatientAddresses](
      state,
      { payload: patientAddresses }
    ) {
      return {
        ...state,
        patientAddresses
      }
    },

    [setMedicalDeviceOrderingPatientProfile](
      state,
      { payload: patientProfile }
    ) {
      return {
        ...state,
        patientProfile
      }
    },

    [setMedicalDeviceOrderingTypeList](state, { payload: typeList }) {
      return {
        ...state,
        typeList
      }
    },

    [resetMedicalDeviceOrdering]() {
      return initialState
    }
  },
  initialState
)
